// Fallback Department/Designation options for the New/Edit member modals,
// used only when the workspace has none configured in the backend
// (the backend lists take precedence whenever they have entries).

const FALLBACK_DEPARTMENTS = [
  'Others', 'Contractors', 'Product Development', 'Development', 'BPO', 'Izenda', 'ChartRequest', 'Full Cycle',
];

const FALLBACK_DESIGNATIONS = [
  'Others', 'Software Developer', 'Senior Data Scientist', 'Team Lead', 'Business Process Analyst',
  'BI Analyst', 'Customer Success Associate', 'Software Developer II', 'QA Lead', 'Business Analyst',
  'Junior Software Developer', 'Senior Business Analyst', 'QA Manager', 'HR',
];

module.exports = { FALLBACK_DEPARTMENTS, FALLBACK_DESIGNATIONS };
